import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { List, Filter, useListRepository, useFilter } from 'elentari'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import transportadoraConfiavelRepository from './transportadoraConfiavelRepository'
import { CustomTextField } from '../../components/CustomDisabledFields'

const TransportadoraConfiavelFilter = () => {
  const filter = useFilter({})

  return (
    <Filter
      {...filter}
      labels={{
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item xs={12} sm={12}>
          <Field
            fullWidth
            name="nome"
            label="Nome"
            component={CustomTextField}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const TransportadoraConfiavel = props => {
  const [ability] = useAbility()

  const listHook = useListRepository({
    repository: transportadoraConfiavelRepository,
    path: 'transportadoraConfiavel'
  })

  const listOptions = {
    fields: {
      nome: {
        label: 'Nome'
      },
      telefone: {
        label: 'Telefone'
      }
    }
  }

  const actions = getListActions(ability, listHook, 'transportadoraConfiavel')

  return (
    <>
      <TransportadoraConfiavelFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default TransportadoraConfiavel
